/** Default lower bound for Shelly virtual Number components. */
export const VIRTUAL_NUMBER_MIN_VALUE = -999999999999999;

/** Default upper bound for Shelly virtual Number components. */
export const VIRTUAL_NUMBER_MAX_VALUE = 999999999999999;
